var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "2px",
    width: "20px",
    height: "20px",
    style: {
      transform: "'translateY(-3px)'"
    },
    fill: "var(--white)",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.01,5.898L18.97,2.733l-0.634-1.241c-0.414-0.807-1.424-1.14-2.256-0.738L5.373,5.898H7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.683,2.824c-0.148,0-0.296,0.02-0.444,0.059l-2.811,0.745l-8.58,2.271h9.739h4.245L24.307,4.03     C24.104,3.301,23.424,2.824,22.683,2.824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.588,7.042h-0.385h-0.521h-0.523h-3.984H6.529h-1.92H2.992h-0.3H1.688c-0.532,0-1.007,0.238-1.317,0.614     c-0.142,0.173-0.25,0.372-0.31,0.591C0.023,8.385,0,8.528,0,8.675v0.196v1.862v16.142c0,0.901,0.755,1.633,1.685,1.633h24.899     c0.93,0,1.685-0.731,1.685-1.633v-4.558h-9.995c-1.58,0-2.864-1.245-2.864-2.776v-1.496v-0.507v-0.507v-1.123     c0-0.751,0.31-1.434,0.812-1.934c0.445-0.444,1.041-0.745,1.709-0.82c0.111-0.013,0.225-0.02,0.34-0.02h8.598h0.521h0.522h0.357     V8.675C28.271,7.774,27.518,7.042,26.588,7.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.451,14.696c-0.168-0.15-0.367-0.264-0.59-0.339c-0.172-0.056-0.354-0.088-0.545-0.088h-0.045h-0.033h-0.521h-1.884     h-7.56c-0.93,0-1.685,0.732-1.685,1.633v0.813v0.506v0.507v1.81c0,0.902,0.755,1.634,1.685,1.634h9.998h0.045     c0.191,0,0.373-0.032,0.545-0.089c0.223-0.071,0.422-0.189,0.59-0.34C29.788,20.445,30,20.014,30,19.537v-3.636     C30,15.424,29.788,14.993,29.451,14.696z M21.791,18.045c0,0.45-0.378,0.816-0.843,0.816h-0.56c-0.465,0-0.842-0.366-0.842-0.816     v-0.543c0-0.262,0.125-0.493,0.323-0.641c0.146-0.107,0.323-0.176,0.519-0.176h0.142h0.418c0.465,0,0.843,0.365,0.843,0.816V18.045     z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a98f71bf0f38b3ac42eaf56b98615230.svg";
export { ForwardRef as ReactComponent };